import React, { useEffect, useState } from "react";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import GRISidebar from "../../../../Layout/GRISidebar";
import styles from "../../../../styles/gri/general.module.css";
import InputField from "../../../../Components/Masters/InputField";
import { Box, Button, Typography } from "@mui/material";
import EastIcon from "@mui/icons-material/East";
import { get, put } from "../../../../utils/api";
import { useNavigate, useParams } from "react-router-dom";
import { validateNumberInput } from "../../../../utils/validateFields";
import MessagePopup from "../../../../Components/Masters/MessagePopup";
import DynamicTable from "../../../../Components/Common/DynamicTable";
import { restructureData } from "../../../../utils/restructureData";
import { validateOptionalTable } from "../../../../utils/validateTable";

import ReviewBox from "../../../../Components/Common/ReviewBox";
import { currentYear } from "../../../../utils/generateYearRanges";

const GRI206_1 = ({ hide }) => {
   const [griReview, setGriReview] = useState(() => JSON.parse(localStorage.getItem("griReview")));
 const inputData = [
    {
      fieldName: "legalOutcomes",
      title:
        "b. What are the main outcomes of the legal actions that have been completed during the reporting period, including any decisions or judgments?",
      type: "array",
      fields: [
        {
          fieldName: "legalAction",
          title: "Legal Action Taken",
          type: "text",
          placeholder: "Enter Text",
          width: "40%",
        },
        {
          fieldName: "outCome",
          title: "Main Outcome",
          type: "text",
          placeholder: "Enter Text",
          width: "40%",
        },
      ],
    },
  ];

  const questionData = [
    {
      fieldName: "pending",
      title: "Pending",
      type: "number",
      placeholder: "Enter Number",
      width: "48.5%",
    },
    {
      fieldName: "completed",
      title: "Completed",
      type: "number",
      placeholder: "Enter Number",
      width: "48.5%",
    },
  ];

  const navigate = useNavigate();
  const { id } = useParams();
  const [disabled, setDisabled] = useState(false);
  const [errors, setErrors] = useState({});
  const [tables, setTables] = useState([]);
  const [tabErrors, setTabErros] = useState({});
  const [data, setData] = useState({});
  const [formData, setFormData] = useState({});
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const res = await get(`/gri/get?Id=${id}&type=GRI200`);
      const res1 = res?.data?.data?.GRI200?.antiCompetitiveBehavior;
      if (res?.data?.data?.year ? res?.data?.data?.year < currentYear -1 : false) setDisabled(true);
      setData(res1);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    setFormData({
      pending: data?.numberOfLegalAction?.pending || "",
      completed: data?.numberOfLegalAction?.completed || "",
    });
  }, [data]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (!validateNumberInput(value)) return;
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    console.log("Updated FormData:", formData);
  };

  const validateForm = () => {
    const newErrors = {};
    questionData.forEach((el) => {
      if (!formData[el.fieldName] || formData[el.fieldName] === "") {
        newErrors[el.fieldName] = "Required";
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!disabled) {
      // let v1 = validateForm();
      let v2 = validateOptionalTable(inputData, tables, setTabErros);

      if (!v2) return;

      let transformedData2 = {
        antiCompetitiveBehavior: {
          numberOfLegalAction: formData,
          ...restructureData(tables),
        },
        type: "GRI200",
        submitted206_1: true,
      };

      try {
        const res = await put(`/gri/update?Id=${id}`, transformedData2);
        setsnackOpen({
          open: true,
          message: res.data.message,
          severity: "success",
        });
        navigate(`/gri/economic-performance/207-1/${id}`);
      } catch (error) {
        setsnackOpen({
          open: true,
          message: error.data.message,
          severity: "error",
        });
      }
    } else {
      navigate(`/gri/economic-performance/207-1/${id}`);
    }
  };

  const renderContent = ({ hide }) => (
    <>
      <MessagePopup {...{ snackOpen, setsnackOpen }} />{" "}
      {/* <Box sx={{ display: "flex" }}> */}
      <p className={styles.section_heading} style={{marginBottom: hide ? "-1rem" : "0"}}>
        206 : Anti-competitive Behaviour 2016
      </p>
      <p className={styles.main_heading}>
        206-1 : Legal actions for anti-competitive behavior, anti-trust, and
        monopoly practices
      </p>
      {/* </Box> */}
      {/* a */}
      <p
        className={styles.ques_heading}
        style={{  marginTop: hide ? "-1rem" : "2rem" }}
      >
        a. How many legal actions, either pending or completed during the
        reporting period, involve allegations of anti-competitive behavior and
        violations of anti-trust and monopoly legislation, with the organization
        identified as a participant?
      </p>
      <Box sx={{ display: "flex", gap: 1 }}>
        {questionData.map((el) => (
          <Box sx={{ width: el.width, ml: 2 }}>
            <Typography
              sx={{
                fontWeight: 500,
                fontSize: "15px",
                fontFamily: "inter",
                lineHeight: "22px",
              }}
            >
              {el.title}
            </Typography>
            <InputField
              placeholder={el.placeholder || "Enter Text"}
              fieldName={el.fieldName}
              value={formData?.[el.fieldName] || ""}
              handleChange={handleChange}
              errors={!!errors[el.fieldName]} // Check if there's an error for this field
              disabled={disabled}
            />

            {errors[el.fieldName] && (
              <p
                style={{
                  lineHeight: "1.2",
                  margin: "2px 0",
                  marginTop: "5px",
                  color: "#d34040",
                  fontSize: "10px",
                  fontStyle: "italic",
                }}
              >
                {errors[el.fieldName]}
              </p>
            )}
          </Box>
        ))}
      </Box>
      <DynamicTable
        {...{
          inputData,
          tables,
          setTables,
          errors: tabErrors,
          setErrors: setTabErros,
          disabled: disabled,
          data: data,
          hide
        }}
      />
    </>
  );

  return (
    <>
      {!hide ? (
        <MainDashboardLayout sidebar={<GRISidebar />}>
          {renderContent({ hide })}

          <>
            {!griReview ? (
              <Box sx={{ ml: "1rem", width: "98%" }}>
                <ReviewBox url={"/gri"} handleSubmit={handleSubmit} />
              </Box>
            ) : (
              <Box textAlign="right" sx={{ mt: 3 }}>
                <Button
                  onClick={handleSubmit}
                  variant="contained"
                  sx={{
                    bgcolor: "#1C486B",
                    textTransform: "none",
                    mt: 3,
                    mb: 5,
                  }}
                >
                  Save & Continue <EastIcon sx={{ ml: 2 }} />
                </Button>
              </Box>
            )}
          </>
        </MainDashboardLayout>
      ) : (
        renderContent({ hide })
      )}
    </>
  );
};

export default GRI206_1;
